const [, featureToggle] =
  document.location.search.match(/(?:\?|&)ft=(.+)(?:&|$)/) || [];

if (featureToggle) {
  featureToggle.split(',').forEach((feature) => {
    document.cookie = `${feature};path=/`;
  });
}
